import { imageBaseUrl } from '../config';

const getImage = (
  hash,
  quality: 'normal' | 'high' | 'low' | 'original' = 'normal'
) =>
  hash
    ? `${imageBaseUrl}${hash}` +
      (quality === 'normal'
        ? '?pt=m500'
        : quality === 'high'
        ? '?pt=m1000'
        : quality === 'low'
        ? '?pt=b1000'
        : '')
    : null;

const getHash = (src = '') => {
  if (typeof src !== 'string') return null;
  const srcWithoutBase = src.split('/m/')[1] || '';
  return srcWithoutBase.split('?pt=')[0];
};

export { getImage, getHash };
